import { useEffect } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { APP_CONFIG } from "../config";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../contexts/AuthContext";

export const useSupportWebSocket = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const client = new Client({
      webSocketFactory: () =>
        new SockJS(`${APP_CONFIG.API_BASE_URL}/ws/support`, null, {
          transports: ['websocket', 'xhr-streaming', 'xhr-polling']
        }),
      reconnectDelay: 5000,
      onConnect: () => {
        client.subscribe("/user/queue/support", (message) => {
          const event = JSON.parse(message.body);
          queryClient.invalidateQueries({ queryKey: ["supportTickets"] });
          queryClient.invalidateQueries({
            queryKey: ["ticket", event.ticketId],
          });
          queryClient.invalidateQueries({ queryKey: ["supportUnreadCount"] });
        });

        if (user.role === "SUPER_ADMIN") {
          client.subscribe("/user/queue/platform-support", () => {
            queryClient.invalidateQueries({
              queryKey: ["adminSupportTickets"],
            });
            queryClient.invalidateQueries({ queryKey: ["supportUnreadCount"] });
          });
        }
      },
      onStompError: (frame) => {
        // Використовуємо warn замість error, щоб Parcel не блокував UI червоним екраном.
        // Сокети на локалці можуть відпадати через CORS обмеження для HttpOnly куків.
        console.warn(
          "WebSocket Connection Warning: " + frame.headers["message"],
        );
      },
      onWebSocketError: (event) => {
        console.warn("WebSocket Error observed. Falling back to HTTP polling.");
      },
    });

    client.activate();

    return () => {
      client.deactivate();
    };
  }, [queryClient, user]);
};
